import stripTags from 'lib/utils/StripTags';

export default {
    filters: {
        stripTags: function(str){
            return stripTags(str);
        }
    }
};